import { render, staticRenderFns } from "./2-Signature.vue?vue&type=template&id=0c2140d2&"
import script from "./2-Signature.vue?vue&type=script&lang=js&"
export * from "./2-Signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports